import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { setLocale, SUPPORTED_LOCALES, type SupportedLocale } from '../../../i18n/i18n';

interface LanguageSelectionProps {
  compact?: boolean;
}

// ── Tailwind class bundles ────────────────────────────────────────────────
const TOGGLE_BASE =
  'inline-flex items-center justify-center h-7 px-[10px] rounded-md cursor-pointer' +
  ' border border-solid border-[var(--color-border)]' +
  ' bg-[var(--color-bg-elevated)] text-[var(--color-text-secondary)] text-[13px]' +
  ' transition-[background-color,color,border-color] duration-[150ms] ease-linear' +
  ' hover:border-[var(--color-accent)] hover:text-[var(--color-text-primary)]';

const TOGGLE_ACTIVE_EXTRA =
  ' !text-[var(--color-accent)] !border-[var(--color-accent)]';

const LanguageSelection: React.FC<LanguageSelectionProps> = ({ compact = false }) => {
  const { i18n, t } = useTranslation();
  const isEnglish = i18n.language === SUPPORTED_LOCALES.enUS;

  const handleToggle = useCallback((): void => {
    const next: SupportedLocale = isEnglish
      ? SUPPORTED_LOCALES.zhCN
      : SUPPORTED_LOCALES.enUS;
    void setLocale(next);
  }, [isEnglish]);

  const labelKey = (() => {
    if (compact) {
      return isEnglish ? 'header.language.enShort' : 'header.language.zhShort';
    }
    return isEnglish ? 'header.language.en' : 'header.language.zh';
  })();
  const label = t(labelKey);

  return (
    <button
      type="button"
      className={TOGGLE_BASE + (isEnglish ? TOGGLE_ACTIVE_EXTRA : '')}
      onClick={handleToggle}
      aria-label={t('header.profile.language')}
    >
      {label}
    </button>
  );
};

export default LanguageSelection;
